'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Events;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Events() {
  return _react2.default.createElement(
    'div',
    { className: 'Events container' },
    _react2.default.createElement(_components.EventsWithFilters, { title: 'R\xE9sultats de recherche' })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Events.js
// module id = 1140
// module chunks = 0